import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    animations: [
        trigger('shrinkExpand', [
            transition(':enter', [
                style({ height: '0px', minWidth: '0px', maxWidth: '0px', opacity: 0 }),
                animate(
                    '350ms cubic-bezier(0.1, -0.6, 0.2, 0)',
                    style({ height: '*', minWidth: '*', maxWidth: '*', opacity: 1 })
                )
            ]),
            transition(':leave', [
                animate(
                    '350ms cubic-bezier(0.1, -0.6, 0.2, 0)',
                    style({ height: '0px', minWidth: '0px', maxWidth: '0px', opacity: 0 })
                )
            ])
        ])
    ]
})
export class LoadingIndicatorComponent {
    contrast = false;
    shadow = true;
    text = true;
    isHealthineersApp = false;
}
